var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge",style:({ 'background-color': _vm.serverStatus.bgColor })},[_c('div',{staticClass:"circle"}),_vm._v("\n  "+_vm._s(_vm.serverStatus.type)+" Server\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23b3273e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/ServerStatusBadge.vue
// module id = null
// module chunks = 